// extracted by mini-css-extract-plugin
export default {"component":"FaqTips_component__ZQuHK","title":"FaqTips_title__GjwtP","container":"FaqTips_container__-G7La","link":"FaqTips_link__wu5MB","description":"FaqTips_description__L0znN"};